import { requestWithToken as request } from "./api";

export const downloadObligationsToSheet = (params = {}) =>
    request.post("/download_obligations/?format=json", params);

export const downloadMovementsToSheet = (params = {}) =>
    request.post("/download_movements/?format=json", params);

export const exportClassificationsToSheet = (params = {}) =>
    request.post("/export_classifications/?format=json", params);
